import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import {
    collection,
    addDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";
import { db } from "../../firebase"; // <-- adjust path to your firebase.js
import { useParams } from "react-router-dom";

import Shopheader from '../Shop/Shopheader';
import Mashalheader from '../Mashal/Mashalheader'
import Wholesalerheader from '../Wholesale/Wholesaleheader';


function Productsize() {
    const { category } = useParams(); // dynamic value from URL

    const [sizes, setSizes] = useState([]);
    const [newSize, setNewSize] = useState("");
    const [editingId, setEditingId] = useState(null);

    // Fetch product sizes
    const fetchSizes = async () => {
        const querySnapshot = await getDocs(collection(db, "productsizes"));
        const data = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setSizes(data);
    };

    useEffect(() => {
        fetchSizes();
    }, []);

    // Add new size
    const handleAdd = async () => {
        if (!newSize.trim()) return;
        await addDoc(collection(db, "productsizes"), { size: newSize });
        setNewSize("");
        fetchSizes();
    };

    // Update size
    const handleUpdate = async (id) => {
        if (!newSize.trim()) return;
        const docRef = doc(db, "productsizes", id);
        await updateDoc(docRef, { size: newSize });
        setEditingId(null);
        setNewSize("");
        fetchSizes();
    };

    // Delete size
    const handleDelete = async (id) => {
        const docRef = doc(db, "productsizes", id);
        await deleteDoc(docRef);
        fetchSizes();
    };

    return (
        <Box sx={{ p: 3 }}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}
            <Typography variant="h5" gutterBottom>
                प्रोडक्ट साईज
            </Typography>

            {/* Add / Update Form */}
            <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                <TextField
                    label="Enter साईज"
                    variant="outlined"
                    size="small"
                    value={newSize}
                    onChange={(e) => setNewSize(e.target.value)}
                />
                {editingId ? (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleUpdate(editingId)}
                    >
                        Update
                    </Button>
                ) : (
                    <Button variant="contained" color="success" onClick={handleAdd}>
                        Add
                    </Button>
                )}
            </Box>

            {/* Sizes List */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><b>प्रोडक्ट</b></TableCell>
                            <TableCell align="right"><b>Actions</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sizes.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.size}</TableCell>
                                <TableCell align="right">
                                    <IconButton
                                        color="primary"
                                        onClick={() => {
                                            setEditingId(item.id);
                                            setNewSize(item.size);
                                        }}
                                    >
                                        <Edit />
                                    </IconButton>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        <Delete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                        {sizes.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={2} align="center">
                                    No product sizes found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default Productsize;
